export default "__VITE_ASSET__BfRCJhSz__"